import { render, staticRenderFns } from "./FundDestinations.vue?vue&type=template&id=2913b3fe&scoped=true"
import script from "./FundDestinations.vue?vue&type=script&lang=js"
export * from "./FundDestinations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2913b3fe",
  null
  
)

export default component.exports